// @core/api/endpoints/secret/get_ca.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetCAResponse,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * Get CA certificate
 * Returns the CA certificate in PEM format. This is typically a public endpoint for clients to trust the CA.
 * @public This endpoint does not require authentication
 */
export async function GetCA(
  engine_id: string,
  options?: RequestOptions
): Promise<GetCAResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/engines/:engine_id/pki/ca`;
  requestPath = requestPath.replace(':engine_id', encodeURIComponent(engine_id));
  const requestOptions = { ...options, skipAuth: true };
  return client.get<GetCAResponse>(requestPath, { ...requestOptions });
}
